import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

const ConsultationCalculator = () => {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
        const nombreConsultations = Math.max(1, values.nombre_consultations || 1);
        if (values.duree_seance && nombreConsultations) {
            const dureeConsultation = Math.floor(values.duree_seance / nombreConsultations);
            setFieldValue('duree_consultation', dureeConsultation);
            if (nombreConsultations !== values.nombre_consultations) {
                setFieldValue('nombre_consultations', nombreConsultations);
            }
        }
    }, [values.duree_seance, values.nombre_consultations, setFieldValue]);

    return null;
};

export default ConsultationCalculator;
